import { FC } from 'react';
import { IconType } from 'react-icons';
import { twMerge } from 'tailwind-merge';
import { Icon as IconComponent } from '@/components/shared/icons/Icon';

interface Props {
  title: string;
  Icon: IconType;
  value: string;
  className?: string;
}

export const SummaryCard: FC<Props> = ({ title, Icon, value, className }) => {
  return (
    <div
      className={twMerge(
        'flex flex-col lg:flex-row border-b lg:border-r lg:border-b-0 last:border-0 p-2 w-full h-full',
        className
      )}
    >
      <div className="relative m-2 w-full h-full">
        <p className="font-semibold">{title}</p>
        <p className="font-bold text-2xl">{value}</p>
        <div className="absolute top-0 right-0">
          <IconComponent Icon={Icon} theme="primary" big />
        </div>
      </div>
    </div>
  );
};
